<section *ngIf="this.hasInvoice" class="recent-invoice">
  <div class="flex items-center gap-2">
    <img src="/dashboard/clock.svg" alt="" />
    <h2>Most recent invoice</h2>
  </div>
  <div class="divider"></div>
  <div class="flex-wrap w-full invoice-card">
    <div class="w-full pb-3 invoice-details">
      <div class="items">
        <p>Date</p>
        <strong>{{latest_invoice()?.createdAt | date}}</strong>
      </div>
      <div class="items">
        <p>Invoice number</p>
        <strong>{{latest_invoice()?.invoice_number}}</strong>
      </div>
      <div class="items">
        <p>Amount</p>
        <strong>{{latest_invoice()?.including_tax | currency: 'USD'}}</strong>
      </div>
      <div class="items">
        <p>Due date</p>
        <strong>{{latest_invoice()?.due_date | date}}</strong>
      </div>
      <div class="items">
        <p>Period</p>
        <strong>{{latest_invoice()!.lines.data[0].period_start | date}}</strong>
      </div>
      <div class="items">
        <p>Status</p>
        <span [ngClass]="{'paid': latest_invoice()?.status === 'PAID' || latest_invoice()?.status === 'PAID_1'}">{{latest_invoice()?.status}}</span>
      </div>
    </div>
    <button class="download-button" (click)="downloadLatest()" type="button"> <i class="mr-2 ri-download-2-line"></i> Download Invoice</button>
  </div>
</section>
